// The variable names come from the server catalogue, never a separate UI list.
export function templateIssues(body, names) {
  const slots = /{{\s*([a-z][a-z0-9_]*)\s*}}/g;
  const unknown = [...new Set([...body.matchAll(slots)].map(match => match[1]))].filter(name => !names.includes(name));
  const remaining = body.replace(slots, '');
  return [...unknown.sort().map(name => ({ code: 'unknown_variable', name })),
    ...(/{{/.test(remaining) || /{{{|{%|%}|{#|#}/.test(body) ? [{ code: 'invalid_syntax' }] : [])];
}

export function slotCompletion(body, cursor) {
  const match = body.slice(0, cursor).match(/{{\s*([a-z0-9_]*)$/);
  return match ? { start: cursor - match[0].length, query: match[1] } : null;
}

export function insertSlot(body, start, end, name) {
  const completion = start === end ? slotCompletion(body, start) : null;
  const from = completion ? completion.start : start;
  const until = completion && body.slice(end, end + 2) === '}}' ? end + 2 : end;
  const slot = `{{${name}}}`;
  return { body: body.slice(0, from) + slot + body.slice(until), cursor: from + slot.length };
}
